import React, { useEffect, useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from '@mui/icons-material/Download';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { packageServices } from "../../services/packageServices";
import Switch from "@mui/material/Switch";
import Filter from "../filter/filter";
import _ from "lodash";
import { Backdrop, CircularProgress } from "@mui/material";
import axios from "axios";
import { rfqServices } from "../../services/rfqServices";
import AlertComponent from "../alert/alert";
import { UserObj } from "../../services/localStarage";
import { getSecPermission, urlConstants, strToDate, isEmptyDash,trimString } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import { projectServices } from "../../services/projectServices";
import { usePreviousLocation } from "../../components/withSidebar/PreviousLocationContext";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CustomSearchDropdown from "../common/customSearchDropdown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { downloadFile } from "../buyerPurchaseOrder/index.js"; 
import checkImage from "../../assests/images/check-circle.png";

const initialColumns = [
  { id: "packageCode", label: "Package Code", isSort: true, sortLabel: "", isFiltered: false },
  { id: "packageName", label: "Package Name", sisSort: true, sortLabel: "", isFiltered: false },
  { id: "packageStatus", label: "Package Status", sisSort: true, sortLabel: "", isFiltered: false },
  { id: "packageType", label: "Package Type", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectName", label: "Project Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectCode", label: "Project Code", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectLocation", label: "Project Location", isSort: true, sortLabel: "", isFiltered: false },
  { id: "capacity", label: "Capacity", isSort: true, sortLabel: "", isFiltered: false },
  { id: "packageCreationDate", label: "Project Creation Date", isSort: true, sortLabel: "", isFiltered: false },
  { id: "COD", label: "COD - As per PPA", isSort: true, sortLabel: "", isFiltered: false },
  { id: "packageCategory", label: "Package Category", isSort: true, sortLabel: "", isFiltered: false },
  { id: "boqQty", label: "BOQ Qty", isSort: true, sortLabel: "", isFiltered: false },
  { id: "rfqQty", label: "RFQ Qty", isSort: true, sortLabel: "", isFiltered: false },
  { id: "balanceQty", label: "Balance Qty", isSort: true, sortLabel: "", isFiltered: false },
  { id: "noOfRfq", label: "No. of RFQ", isSort: true, sortLabel: "", isFiltered: false },
  { id: "bom", label: "BOM", isSort: true, sortLabel: "", isFiltered: false },
  { id: "tendorDrawing", label: "Tender Drawing", isSort: true, sortLabel: "", isFiltered: false },
  { id: "technicalSpecification", label: "Technical Specification", sortable: true, isFiltered: false },
  { id: "rfqCode", label: "RFQ Code", sortable: true, isFiltered: false },
  { id: "rfqDate", label: "RFQ Date", sortable: true, isFiltered: false },
  { id: "rfqStatus", label: "RFQ Status", sortable: true, isFiltered: false },
  { id: "createdBy", label: "Created By", sortable: true, isFiltered: false },
  { id: "updatedAt", label: "last updated on", sortable: true, isFiltered: false },
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function PackageListing() {
  const [columns, setColumns] = useState(initialColumns);
  const navigate = useNavigate()
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);
    setColumns(reorderedColumns);
  };
  const [opencreatenewrfq, setOpenCreateNewRfq] = useState(false);
  const [packagecodesrequested, setPackageCodesRequested] = useState("");
  const [opencreaterfqnewtoggler, setOpenCreateRfqnewToggler] =
    useState("AgainstPackage");

  const [openpackagelistingrfq, setOpenPackageListingRfq] = useState(false);
  const [formData, setFormData] = useState({
    projectName: "",
    location: "",
    capacity: "",
    COD: "",
  });
  const [secPackagePermission, setSecPackagePermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [secRFQPermission, setSecRFQPermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [secCreateRFQPermission, setCreateSecRFQPermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [secCreatePackagePermission, setCreatePackagePermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [secPackageDownloadPermission, setPackageDownloadPermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [packageCreationlist, setPackageCreationlist] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    packages: [],
  });

  const [ApprovalFlow, setApprovalFlow] = useState("Simultaneous");
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClose = (event, reason) => {
    setAnchorEl(null);
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [rfqType, setRfqType] = useState("TWO_BID");
  const [inputPage, setInputPage] = useState(packageCreationlist?.currentPage || 1);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= packageCreationlist?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(packageCreationlist?.currentPage);
      }
    }
  };

  const handleCheckboxChange = (e, row) => {
    const { checked } = e.target;

    if (checked) {
      setSelectedRows(prev => [...prev, row]);
    } else {
      setSelectedRows(prev => prev.filter(selectedRow => selectedRow._id !== row._id));
    }
  };

  const isButtonDisabled = selectedRows.length !== 1;

  const handleRfqTypeChange = (event) => {
    setRfqType(event.target.checked ? "TWO_BID" : "ONE_BID");
  };
  const handleRfqApprovalFlow = (event) => {
    setApprovalFlow(event.target.checked ? "Simultaneous" : "Linear");
  }

  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const validateForm = () => {
    const newErrors = {};
    if (!formData.projectName)
      newErrors.projectName = "Project Name is required";
    if (!formData.location) newErrors.location = "Project Location is required";
    if (!formData.capacity) newErrors.capacity = "Capacity is required";
    if (!formData.COD) newErrors.COD = "Calendar Date is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);
    packageServices
      .addNewProject(formData)
      .then((res) => {
        // setProjectCode(res?.data?.data?.projectCode);
        // setOpenCreateProjectsListing(false);
        // setOpenCreateProjectSuccessfully(true);
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    let permissionObj = getSecPermission("PACKAGE_LISTING");
    let permissionObj2 = getSecPermission("RFQ_LISTING");
    let permissionObj3 = getSecPermission("CREATE_RFQ_PACKAGE");
    let permissionObj4 = getSecPermission("CREATE_PACKAGE");
    let permissionObj5 = getSecPermission("DOWNLOAD_PACKAGE");
    console.log(permissionObj);
    setSecPackagePermission(permissionObj);
    setSecRFQPermission(permissionObj2);
    setCreateSecRFQPermission(permissionObj3);
    setCreatePackagePermission(permissionObj4);
    setPackageDownloadPermission(permissionObj5);

    if (previousLocation?.pathname?.includes("/admin/Project-Manager-Package-Detail")) {
      const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
      if (UserObjInit.prevLocationData.componentName == "PACKAGE_LISTING") {
        setFilterText(UserObjInit.prevLocationData?.filterText);
        setRequestPayload(UserObjInit.prevLocationData?.requestPayload);
        setFilterFormData(UserObjInit.prevLocationData?.filterFormData);
      }
    }
  }, []);

  const getPackageListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }
    packageServices
      .getPackageListing(param)
      .then((res) => {
        if (res.data.success === true) {
          setPackageCreationlist(res?.data?.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getPackageListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }
  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);

    }, 800),
    []
  );
  const projectsubmit = () => {

    if (opencreaterfqnewtoggler === "AgainstPackage" && selectedProjectCode === "") {
      setAlertComponent({
        open: true,
        type: "error",
        message: `Please Enter the Project code `,
      });
      return;

    }
    else if (opencreaterfqnewtoggler === "AgainstPackage" && selectedProjectCode?.selectedLable != "") {
      projectServices
        .getProjectDetails(selectedProjectCode?.selectedValue)
        .then((res) => {
          if (res.data.success === true) {
             navigate(`/admin/Package-Creation-Form?p=${selectedProjectCode?.selectedValue}`)
          } else {
            setAlertComponent({
              open: true,
              type: "error",
              message: `No Data Found `,
            });
          }
        })
        .catch(function (error) {
          setAlertComponent({
            open: true,
            type: "error",
            // message: `${error?.response?.data?.message}`,
            message: "Please Enter Correct Project Code",
          });
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
    else if (opencreaterfqnewtoggler === "WithoutPackage") {
      navigate(`/admin/Package-Creation-Form`)
    }
  }


  const Cnrsubmit = () => {
    setIsLoading(true);

    let bodydata = {};

    bodydata = {
      "againstPackage": true,
      "packageCode": selectedRows[0].packageCode,
      rfqType
    }
    if (rfqType === 'TWO_BID') {
      bodydata.approvalFlow = ApprovalFlow;
    }

    rfqServices.createNewRfq(bodydata)
      .then((res) => {
        if (res.data.success === true) {
          setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
          navigate(`/admin/Buyer-Bidding-Rfq-Creaction-Form/${res.data.data?._id}`);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getPackageListing(requestPayload, filterText);
  };

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder === "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getPackageListing(updatedPayload, filterText, formDataa || '');
    const updatedColumns = columns.map((col) => {
      const isFiltered = Object.keys(formDataa).includes(col.id);
      return { ...col, isFiltered };
    });
    setColumns(updatedColumns);
    const filters = Object.keys(formDataa).map((key) => {
      if (key.endsWith('_from_date') || key.endsWith('_to_date')) {
        const fieldBaseName = key.replace('_from_date', '').replace('_to_date', '');
        return `${fieldBaseName}: ${formDataa[key.replace('_from_date', '') + '_from_date'] || ''} to ${formDataa[key.replace('_from_date', '') + '_to_date'] || ''}`;
      }
      // return `${key}: ${formDataa[key]}`;
      return `${key}:${formDataa[key]}`;
    });
    setActiveFilters(filters);
  };

  const handleResetFormSubmit = () => {
    getPackageListing(requestPayload, filterText, {});
    const resetColumn = columns.map(col => ({
      ...col, isFiltered: false,
    }))
    setColumns(resetColumn);
    setActiveFilters([]);
    setFilterFormData({});
  }
  const downloadPackageDoc = () => {
    setIsLoading(true);
    let proId = selectedRows[0]?._id;
    if (proId) {
      axios({
        method: 'POST',
        url: `${urlConstants.BASE_URI_DEV}/v1/internal/packages/download-documents`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${UserObj?.accessToken}`
        },
        data: JSON.stringify({ packageId: proId }),
        responseType: 'blob'
      })
        .then((res) => {
          if (res && res.data) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'package-document.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  const handleNewRfqClose = () => {
    setRfqType('TWO_BID');
    setApprovalFlow('Simultaneous');
    setOpenPackageListingRfq(false);
  };

  const previousLocation = usePreviousLocation();
  const navigateUrl = (param) => {
    navigate(param);
  };

  const redirectToDetails = (redirectId) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: "PACKAGE_LISTING",
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(`/admin/Project-Manager-Package-Detail/${redirectId}`);
  };
  const [activeFilters, setActiveFilters] = useState([]);

  const handleRemoveFilter = (filterIndex, valueToRemove) => {
    // Splitting the label and values of the target filter
    const [targetLabel, targetValues] = activeFilters[filterIndex].split(':');
    const valuesArray = targetValues.split(',');

    // Removing the value to be removed
    const updatedValues = valuesArray.filter(val => val.trim() !== valueToRemove);

    let updatedFilters = [...activeFilters];

    // If no values remain, remove the entire filter
    if (updatedValues.length === 0) {
      updatedFilters = updatedFilters.filter((_, i) => i !== filterIndex);
    } else {
      // Update the target filter with remaining values
      updatedFilters[filterIndex] = `${targetLabel}:${updatedValues.join(',')}`;
    }

    setActiveFilters(updatedFilters);

    // Prepare the updated form data
    const updatedFormData = { ...filterFormData };
    if (!updatedValues.length) {
      // Remove the key entirely if no values remain
      delete updatedFormData[targetLabel];
    } else {
      // Update the form data with remaining values
      updatedFormData[targetLabel] = updatedValues.join(',');
    }

    handleFilterFormSubmit(updatedFormData);
  };
  const formatLabel = (label) => {
    const formattedLabel = label.replace(/([A-Z])/g, ' $1').trim();
    return formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
  };
  const handleFilterButtonClick = () => {
    const filterButton = document.querySelector('.filter_box');
    if (filterButton) {
      const clickableElement = filterButton.querySelector('button') || filterButton;
      clickableElement.click();
    } else {
      console.error('No element found with class filter_box');
    }
  };
  const [selectedProjectCode, setSelectedProjectCode] = useState(null);
  const onSearchSelectChange = (param) => {
    setSelectedProjectCode(param);
  }

  const [downloadEl, setdownloadEl] = React.useState(null);
  const [confirmObj, setConfirmObj] = useState({});
  const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
  useState(false);
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
      useState(false);
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };

  const openConfirmModal = (param) => { 
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    } 
    setConfirmObj(obj);
    setOpenHeaderLevelExcelModal(true);
  }
  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenHeaderLevelExcelModal(false);
  }

  const downloadPO = (type) => {
    setIsLoading(true);
    let bodyData = { 
      "type": confirmObj?.id, // "line-item", header,
      ...filterFormData
    };

    if (!isEmptyDash(filterText)) {
      bodyData["search"] = filterText;
    }

    let fileName = "";  
    if (confirmObj?.id == "header") {
      fileName = "Package_Header_Level_Excel.xlsx";
    }
    if (confirmObj?.id == "line-item") {
      fileName = "Package_Line_Item_Level_Excel.xlsx";
    }
    const data = {
      url: `/v1/internal/packages/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {
        if (isEmptyDash(response)) {
          setOpenHeaderLevelExcelModal(false);
          setOpenHeaderLevelSucessfullyModal(true);          
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenHeaderLevelExcelModal(false);
      })

  }


  return (
    <>

      <div className="login-forms">
        <div
          className="text-centers row_purchase_invoice_dragdropcontext_apps_body"
        >
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_mains">
                <h5>Package Listing</h5>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              <div className="create_listing_project">
                <div className="vendor_listing_lr_block_body">
                  {(secCreateRFQPermission?.read == true) && <button
                    onClick={() => {
                      setOpenPackageListingRfq(true);
                    }}
                    style={{ backgroundColor: isButtonDisabled ? "gray" : "#274594" }}
                    className="gate_btn_lr_creations_1"
                    disabled={isButtonDisabled}
                  >
                    <AddIcon />
                    Create New RFQ
                  </button>}
                 

                  {(secCreatePackagePermission?.create == true) && <button
                    onClick={() => {
                      setOpenCreateNewRfq(true);
                    }}
                    className="gate_btn_lr_creations"
                    type="button"
                  >
                    <AddIcon />
                    Create Package
                  </button>
                  
                  }
                </div>

                {(secPackageDownloadPermission?.create === true) && 
                <div className="">
                <button 
                    style={{ backgroundColor: isButtonDisabled ? "gray" : "#274594" }} 
                    className="gate_btn_lr_creations_1 vendor_maine_contents"
                    id="basic-button"
                    aria-controls={download ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={download ? "true" : undefined}
                    onClick={handleClicks}
                  >
                    <DownloadIcon />
                    Download
                  </button>
                  <Menu
                    id="basic-menu"
                    anchorEl={downloadEl}
                    open={download}
                    onClose={handleCloses}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >

                    <MenuItem onClick={() =>downloadPackageDoc()}  disabled={isButtonDisabled}>
                      Download Package Doc
                    </MenuItem>


                    <MenuItem onClick={() => openConfirmModal("header")}>
                     Header Level Excel
                    </MenuItem> 
                    <MenuItem onClick={() => openConfirmModal("line-item")}>
                      Line Item Level Excel
                    </MenuItem>
                  </Menu>
                </div>
              }

                <div>
                  <div className="lets_filter_vendorlist_body_detail filter_box row_filterrbtnvendor_box">
                    <FilterAltOutlinedIcon />
                    <Filter uniqueName="PACKAGES" formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                  </div>
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isLoading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                </div>


              </div>
            </div>
            <div>
              <ul className="project_listing_gap_bcfe_react">
                {activeFilters.slice(0, 3).map((filter, index) => {
                  const [label, value] = filter.split(':');
                  const valuesArray = value.split(',');
                  return (
                    <li key={index} className="project_listing_gap_bcfe_react_one">
                      <strong>{formatLabel(label)}:</strong>
                      {valuesArray.map((val, i) => (
                        <span key={i} className="filter_sel">
                          {val}
                          <button
                            type="button"
                            className="btn-close"
                            style={{ fontSize: "10px", marginLeft: "5px" }}
                            onClick={() => handleRemoveFilter(index, val)}
                          ></button>
                        </span>
                      ))}
                    </li>
                  );
                })}
                {activeFilters.length > 3 && (
                  <button className="btn btn-outline-info" onClick={handleFilterButtonClick}><AddIcon className="add_icons" />{activeFilters.length}</button>
                )}
              </ul>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div style={{ width: "100%", overflow: "hidden" }}
                  className="listing_main listing_main_dragdropcontext_body"
                  // style={{ overflowX: "scroll", marginTop:"-20px" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          {/* <input
                            type="checkbox"
                          /> */}
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className={`vendor_tabels ${column.isFiltered ? 'highlighted_column' : ''}`}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              //  style={{
                              //   cursor: column.sortable
                              //     ? "pointer"
                              //     : "default",
                              // }}
                              >
                                {column.label}
                                {(column.isSort === true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {packageCreationlist?.packages?.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}

                      {packageCreationlist?.packages?.length > 0 && <>
                        {packageCreationlist?.packages?.map((row, rowIndex) => (
                          <tr key={rowIndex} className="maine_tr_vendor">
                            <td>
                              <input
                                type="checkbox"
                                onChange={(e) => handleCheckboxChange(e, row)}
                              />
                            </td>
                            {columns.map((column, index) => (
                              <td key={index}>
                                {column.id === "packageCode" ? (
                                  <Link
                                    className="solutions_block_body"
                                    style={{ textDecoration: "none" }}
                                    to={`/admin/Project-Manager-Package-Detail/${row?._id}`}
                                  >
                                    <span className="list-details-para"
                                      onClick={() => redirectToDetails(row?._id)}
                                    >
                                      {row[column.id] || "N/A"}</span>
                                  </Link>
                                ) : (column.id === "packageCreationDate" || column.id === "rfqDate" || column.id === "COD" || column.id === "updatedAt") ? (
                                  <div>{row[column.id] ? strToDate(row[column.id]) : "N/A"}</div>
                                ) : (
                                  <Tooltip title={row[column.id] || "N/A"}>
                                  {row[column.id] ? trimString(row[column.id], 20) : "N/A"}
                                 </Tooltip>
                                )}
                              </td>
                              
                            ))}
                          </tr>
                        ))}
                      </>}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {packageCreationlist?.packages?.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(packageCreationlist?.pageSize) * Number(packageCreationlist?.currentPage - 1) + 1
                    } to ${Number(packageCreationlist?.pageSize) * Number(packageCreationlist?.currentPage - 1) + Number(packageCreationlist?.packages?.length)} of ${packageCreationlist?.totalItems} `}
                </span>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={packageCreationlist?.totalPages}
                  page={packageCreationlist?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === packageCreationlist?.currentPage) {
                      return (
                        <input
                          className="form-control listing_currentpagination"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}
                />
              </Stack>
            </div>
          </>}

          {/* Create New RFQ Modal */}
          <Modal
            open={opencreatenewrfq}
            onClose={() => setOpenCreateNewRfq(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5 create_rfq" id="exampleModalLabel">
                  Create Package
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreateNewRfq(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div class="header_lineitems">
                  <span onClick={() => setOpenCreateRfqnewToggler("AgainstPackage")} class={opencreaterfqnewtoggler === "AgainstPackage" ? "line-tb" : "header-tb"}>Against Project</span>
                  <span onClick={() => setOpenCreateRfqnewToggler("WithoutPackage")} class={opencreaterfqnewtoggler === "WithoutPackage" ? "line-tb" : "header-tb"}>Without Project</span>
                </div>
                {opencreaterfqnewtoggler === "AgainstPackage" &&
                  <div class="lets_package_number_listing">
                    <label className="package_number_body_vendor_portal_block">
                      Project Code
                    </label>
                    {/* <input
                      type="text"
                      class="form-control"
                      fdprocessedid="8achb"
                      value={packagecodesrequested}
                      onChange={(e) => setPackageCodesRequested(e.target.value)}
                    /> */}

                    <CustomSearchDropdown
                      listingArrName="projects"
                      onSearchSelectChange={onSearchSelectChange}
                      promiseRequest={projectServices?.getProjectListing}
                      additionalData={{
                        lableKeyName1: "projectCode",
                        lableKeyName2: "projectName",
                        valueKeyName: "_id",
                      }}
                      isDisable={false}
                      defaultValue={selectedProjectCode}
                    />

                  </div>}
              </div>
              <div class="closebtn_submit_block_btn">
                <button
                  type="button"
                  class="btn clear_btn_status_block_lists"
                  fdprocessedid="wshspp"
                  onClick={() => setOpenCreateNewRfq(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-success save_next_btns"
                  onClick={projectsubmit}
                >

                  Submit

                </button>
              </div>
            </Box>
          </Modal>

          {/* Create New RFQ Modal  */}
          <Modal
            open={openpackagelistingrfq}
            onClose={() => handleNewRfqClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Create New RFQ
                </h1>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => handleNewRfqClose()}
                ></button>
              </div>
              <div class="modal-body">
                <from>
                  <div>

                    <div className="lets_n_vendor_technical_comercial_staus_listing">
                      <p>One Bid (Only Commercial)</p>
                      <Switch
                        checked={rfqType === 'TWO_BID'}
                        onChange={handleRfqTypeChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                      <p>Two Bid (Comm+Tech)</p>
                    </div>
                    {rfqType === 'TWO_BID' &&
                      <div className="lets_n_vendor_technical_comercial_staus_listing">
                        <p>Linear</p>
                        <Switch
                          checked={ApprovalFlow === 'Simultaneous'}
                          onChange={handleRfqApprovalFlow}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <p>Simultaneous </p>

                      </div>
                    }
                  </div>
                  <div class="closebtn_submit_block_btn">
                    <button
                      type="button"
                      class="btn clear_btn_status_block_lists"
                      onClick={() => handleNewRfqClose()}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      class="btn btn-success save_next_btns"
                      fdprocessedid="37eo4"
                    >
                      <Link
                        style={{ color: "white", textDecoration: "none" }}
                        // to="/admin/Buyer-Bidding-Rfq-Creaction-Form"
                        onClick={Cnrsubmit}
                      >
                        Submit
                      </Link>

                    </button>
                  </div>

                </from>
              </div>
            </Box>
          </Modal>

           <Modal
              open={openheaderlevelexcelmodal}
              onClose={closeConfirmModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelExcelModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download
                     
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={downloadPO}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={closeConfirmModal}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>


            <Modal
              open={openheaderlevelsucessfullymodal}
              onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                  Selected <b>{confirmObj?.text}</b> file has been
                  <br /> downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHeaderLevelSucessfullyModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
        </div>
      </div>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
    </>
  );
}

export default PackageListing;
